<template>
  <div class="jw-map-wrapper">
    <div ref="container"></div>
  </div>
</template>

<script>

import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css';

/**
 * A Generic MapBox wrapper component
 */
export default {
  name: 'MapBox',
  props: {
    accessToken: {
      type: String,
      required: true
    },
    mapStyle: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      map: null,
      mapbox: null
    }
  },
  mounted() {
    console.log("Mounting Mapbox")
    this.mapbox = mapboxgl
    this.mapbox.accessToken = this.accessToken
    this.map = new this.mapbox.Map(
      Object.assign(this.options, {
        container: this.$refs.container,
        style: this.mapStyle
      })
    )
    // this.map.on('error', function() {
    //   // console.log('A MapBox error event occurred.');
    // });
    this.map.on('load', () => {
      console.log("Mapbox Load event")
      this.$emit('load', { map: this.map })
    })
  },
  beforeDestroy() {
    console.log("Destroying Mapbox")
    this.$nextTick(() => {
      if (this.map) this.map.remove()
    })
  }
}
</script>

<style>
.jw-map-wrapper, .jw-map-wrapper .mapboxgl-map {
  position: absolute;
  /* width: 100%;
  height: 100%;
  min-height: 100%;
  min-width: 100%; */
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  transition: all 0.3s ease-in-out;
}

</style>
